import { Injectable } from '@angular/core';
import { Properties } from './properties.model';
import { HttpClient } from '@angular/common/http';
import * as GlobalEnvironment from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {
public props!: Properties;

  private propsFake: Properties = {
    name: 'videoconsulta',
    version: '2.2.0',
  };

  constructor(private readonly http: HttpClient) {}

  loadProps(): Promise<any> {
    if (GlobalEnvironment.environment.production) {
      const promise = this.http.get('package.json').toPromise();
      promise.then((res:any) => {
        const resFormatted = JSON.parse(res.toString());
        this.props = {
          name: resFormatted.name,
          version: resFormatted.version,
        };
      });

      return promise;
    }

    const localPromise = new Promise<void>((resolve) => {
      this.props = this.propsFake;
      resolve();
    });

    return localPromise;
  }
}
